const InfoField = ({ label, value, className, small }) => (
    <div className="d-flex flex-column">
        <span
            className="text-uppercase"
            style={{
                color: '#6c757d',
                letterSpacing: '.5px',
                fontSize: small ? '.7rem' : '.75rem',
                paddingBottom: small ? '' : '2px',
            }}
        >
            {label}
        </span>
        <span className={small ? 'small' : className}>{value}</span>
    </div>
);

export default InfoField;
